import React, { useState } from 'react';
import { FiPlus } from 'react-icons/fi';
import { Helmet } from 'react-helmet-async';
import CarouselTab from './media/tabs/CarouselTab';
import VideosTab from './media/tabs/VideosTab';
import AboutTab from './media/tabs/AboutTab';
import LogoTab from './media/tabs/LogoTab';
import LoginTab from './media/tabs/LoginTab';
import IndexBannerTab from './media/tabs/IndexBannerTab';
import CareerTab from './media/tabs/CareerTab';

const Media = () => {
  const [activeTab, setActiveTab] = useState('carousels');

  const renderTabContent = () => {
    switch (activeTab) {
      case 'carousels':
        return <CarouselTab />;
      case 'videos':
        return <VideosTab />;
      case 'logo':
        return <LogoTab />;
      case 'login':
        return <LoginTab />;
      case 'about':
        return <AboutTab />;
      case 'index-banner':
        return <IndexBannerTab />;
      case 'careers':
        return <CareerTab />;
      default:
        return null;
    }
  };

  return (
    <>
      <Helmet>
        <title>Media Library - Admin Dashboard</title>
      </Helmet>
      <div className="space-y-6">
        <div className="overflow-x-auto -mx-2 sm:mx-0">
          <div className="flex space-x-2 px-2 sm:px-0 min-w-max sm:min-w-0 sm:space-x-4">
            {[
              'carousels',
              'videos',
              'logo',
              'login',
              'about',
              'index-banner',
              'careers'
            ].map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-3 py-2 sm:px-4 sm:py-2 rounded-lg text-sm sm:text-base whitespace-nowrap ${
                  activeTab === tab
                    ? 'bg-indigo-500 text-white'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                {tab.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
              </button>
            ))}
          </div>
        </div>
        {renderTabContent()}
      </div>
    </>
  );
};

export default Media;


